/* View the model at true size, in your room.
   ==========================================================================
   WHY THIS IS THE RIGHT FEATURE FOR THIS STORE
   The single thing people cannot tell from a photo of a miniature is how big
   it actually is. Every product shot here is a close-up on a workbench, which
   tells you nothing about scale. AR answers it in two seconds.

   HOW IT WORKS - and why there is no 3D library here
   Both AR viewers are built into the phone, and both take a URL:

     iOS      AR Quick Look, triggered by <a rel="ar" href="model.usdz">
     Android  Scene Viewer, triggered by an intent:// URL pointing at a .glb

   So this needs no WebGL, no model-viewer, no extra megabytes. It is a button
   that hands a URL to the operating system. That matters on the builder page
   especially, where three.js already owns a WebGL context - a second one for
   an embedded viewer would be waste.

   WHERE THE FILES COME FROM
   Shopify generates the USDZ automatically when a .glb is attached to a
   product as 3D media, and exposes both under /products/<handle>.js. Reading
   them from there rather than hardcoding means the feature survives the model
   being re-uploaded, and it switches itself off if the 3D media is removed.

   KNOWN LIMIT, stated plainly: AR shows the BASE model, not the colours the
   customer picked in the builder. Quick Look and Scene Viewer both need a
   hosted file, and a configured build only exists as materials in the
   browser's WebGL scene. Exporting a per-configuration USDZ would mean
   generating and hosting a file per permutation. The scale question - the
   reason to offer AR at all - is answered either way.

   (Path parsing below splits the pathname rather than using a regex. Not
   style: this file is deployed through a GraphQL block string, where
   backslashes survive literally, so a regex escape would arrive doubled and
   silently stop matching.)
   ========================================================================== */
(function arView() {
  /* Pages that are about one product but are not that product's page. */
  var PAGE_PRODUCT = {
    'build-surron': 'custom-mini-surron',
  };

  /* Where the button wants to live, best first. The in-flow Add to cart is
     listed explicitly and the sticky one is excluded, because `main
     .add-to-cart-button` matches the STICKY bar first on a product page - the
     button ended up docked to the bottom bar instead of sitting with the other
     actions. */
  var PREFERRED = [
    '#pm-3d .pm-share',
    '#pm-3d .pm-addcart',
    '.pm-configure',
    'main .product-details .add-to-cart-button',
  ];
  var FALLBACK = 'main .add-to-cart-button:not(.sticky-add-to-cart__button)';

  /* page-product.js injects .pm-configure, and it can land after this script's
     fetch resolves. Without a wait the chain fell through to the fallback and
     the button anchored to the wrong place. ~2.5s of polling at 150ms. */
  var TRIES = 17;
  var EVERY = 150;

  function handle() {
    var parts = location.pathname.split('/').filter(Boolean);

    var i = parts.indexOf('products');
    if (i > -1 && parts[i + 1]) return parts[i + 1];

    var j = parts.indexOf('pages');
    if (j > -1 && parts[j + 1] && PAGE_PRODUCT[parts[j + 1]]) {
      return PAGE_PRODUCT[parts[j + 1]];
    }
    return null;
  }

  var ua = navigator.userAgent;

  /* Android is tested FIRST and iOS is defined as "not Android, and looks like
     iOS". The two are mutually exclusive in reality, and ordering it this way
     closes a real false positive: the iPad check is `platform === 'MacIntel'
     && maxTouchPoints > 1`, which is correct for iPadOS (it reports itself as
     a Mac) but also matches a desktop Chrome emulating a phone - the platform
     stays MacIntel while touch points get spoofed. That sent an Android test
     device down the Quick Look branch and killed the button. */
  var isAndroid = /Android/.test(ua);
  var isIOS =
    !isAndroid &&
    (/iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

  /* Quick Look needs the browser to actually support rel="ar" - Safari does,
     most iOS in-app browsers do, some do not. Checking beats assuming. */
  function quickLookOk() {
    var a = document.createElement('a');
    return !!(a.relList && a.relList.supports && a.relList.supports('ar'));
  }

  function canDoAR() {
    if (isAndroid) return true;
    if (isIOS) return quickLookOk();
    return false; /* desktop has no AR to hand off to */
  }

  function openIOS(usdz) {
    /* Quick Look only fires from an anchor that contains an image child. */
    var a = document.createElement('a');
    a.setAttribute('rel', 'ar');
    a.href = usdz;
    var img = document.createElement('img');
    img.alt = '';
    img.style.display = 'none';
    a.appendChild(img);
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      a.remove();
    }, 1000);
  }

  function openAndroid(glb, title) {
    var fallback = encodeURIComponent(location.href);
    var url =
      'intent://arvr.google.com/scene-viewer/1.0' +
      '?file=' + encodeURIComponent(glb) +
      '&mode=ar_preferred' +
      '&title=' + encodeURIComponent(title || 'ReRide Co.') +
      '#Intent;scheme=https;package=com.google.ar.core;' +
      'action=android.intent.action.VIEW;' +
      'S.browser_fallback_url=' + fallback + ';end;';
    window.location.href = url;
  }

  function pick(sources, format) {
    for (var i = 0; i < sources.length; i++) {
      if (sources[i].format === format) return sources[i].url;
    }
    return null;
  }

  function findAnchor() {
    for (var i = 0; i < PREFERRED.length; i++) {
      var el = document.querySelector(PREFERRED[i]);
      if (el) return el;
    }
    return null;
  }

  function build(anchor, usdz, glb, title) {
    if (document.querySelector('.pm-ar')) return null;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pm-ar';
    btn.innerHTML =
      '<span class="pm-ar__cube" aria-hidden="true"></span>' +
      '<span class="pm-ar__label">View at true size' +
      '<small>Point your phone at your desk</small></span>';

    btn.addEventListener('click', function () {
      if (isAndroid) openAndroid(glb, title);
      else openIOS(usdz);
    });

    anchor.insertAdjacentElement('afterend', btn);
    return btn;
  }

  function mount(sources, title) {
    var usdz = pick(sources, 'usdz');
    var glb = pick(sources, 'glb');
    if (isIOS && !usdz) return;
    if (isAndroid && !glb) return;

    var left = TRIES;
    (function attempt() {
      var anchor = findAnchor();
      if (anchor) {
        build(anchor, usdz, glb, title);
        return;
      }
      if (--left > 0) {
        setTimeout(attempt, EVERY);
        return;
      }
      /* Waited long enough; take whatever in-flow buy button exists. */
      var last = document.querySelector(FALLBACK);
      if (last) build(last, usdz, glb, title);
    })();
  }

  function init() {
    if (!canDoAR()) return;
    var h = handle();
    if (!h) return;

    fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        if (!p || !p.media) return;
        var model = null;
        for (var i = 0; i < p.media.length; i++) {
          if (p.media[i].media_type === 'model') {
            model = p.media[i];
            break;
          }
        }
        if (!model || !model.sources) return;
        mount(model.sources, p.title);
      })
      .catch(function () {
        /* no AR button; the page is exactly as it was */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.__pmAR = {
    handle: handle,
    canDoAR: canDoAR,
    mount: mount,
    findAnchor: findAnchor,
    platform: { isIOS: isIOS, isAndroid: isAndroid },
  };
})();